export default __webpack_public_path__ + "static/media/62_Random_ZoomOut.2dc85f19.mp4";